module.exports = __webpack_public_path__ + "img/maintainance.3d1479cb.png";